import { Link } from 'react-router-dom';

export const COUNSELVAULT_CONTACT_EMAIL = 'info@counselvaultapp.com';

export default function PublicFooter() {
  return (
    <footer className="cv-public-footer">
      <div>
        <strong>CounselVault</strong>
        <p>Controlled legal-document exchange for correctional facilities and approved attorneys.</p>
      </div>
      <nav aria-label="Legal documents" className="cv-footer-links">
        <Link to="/academy">Academy</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/request-demo">Request a demo</Link>
        <Link to="/legal/terms">Terms</Link>
        <Link to="/legal/privacy">Privacy</Link>
        <Link to="/legal/security">Security</Link>
        <Link to="/legal/facility-authority">Facility Authority</Link>
      </nav>
      <a href={`mailto:${COUNSELVAULT_CONTACT_EMAIL}`} className="cv-footer-contact">Contact CounselVault</a>
    </footer>
  );
}
